import React, { Component } from "react";
import Cache from 'c-cache';
import lang from "../../lang";
import {ImageView, Grade, VIP} from '../../component/user-ui';
import LogoutPop from '../../component/logout';
import NumberUtil from '../../lib/util/number';
import Tooltip from 'rc-tooltip';

class Language extends Component {
	static defaultProps = {
		openInNewTab: false,
		profile: false // 是否显示profile弹出层
	}

	constructor(props) {
		super(props);
		
		this.state = {
			isLoggedIn: UP.Global.isLogin()
		}

		this.cache = new Cache({
			prefix: 'pcuplive'
		});
	}

	goProfile(){
		if (this.props.openInNewTab) {
			let url = location.href.replace(location.hash, '') + window.hashHistory.createHref('/profile');
    		window.open(url);
		} else {
			window.hashHistory.push('/profile');
		}
	}

	login=() =>{
		$.channel.emit('login');
	}

	render() {
		if (this.cache.getCache('isRegisterRealUser')) { // 正式用户
			let user = UP.Global.getUser();

			return (
				<div className="user" ref="user">
					<Tooltip getTooltipContainer={()=>this.refs.user} overlay={this.props.profile ? <UserPop/> : null} placement="bottomRight" trigger={['hover']} overlayClassName="header-popover">
	                    <div className="avatar" ref="avatar" onClick={()=>this.goProfile()}>
							<ImageView src={user.avatar} size={30} circle/>
						</div>
					</Tooltip>
				</div>
			)
		} else {
			return (
				<div className="login" onClick={this.login}>
					<span className="text">{lang.template('登录')}</span>
				</div>
			);
		}
	}
}

class UserPop extends Component  {
	constructor(props) {
		super(props);

		this.state = {
			userInfo : UP.Global.getUser(),
			vipLevel: UP.Global.isVip()
		}
	}

	componentDidMount(){
		$.channel.on('rechargeSuccess', (data)=>{
            this.setState({
            	userInfo: UP.Global.getUser()
            });
        });
	}

	logout() {
		LogoutPop.create();
	}
	
	goURank() {
		hashHistory.push('/profile/contribution');
	}

	goWithdraw() {
		hashHistory.push('/withdraw');
	}
	goPrivilege(){
		hashHistory.push('/profile/vip-privileges');
	}
	goGrade() {
		hashHistory.push('/profile/grade');
	}

	goRecharge() {
		hashHistory.push('/recharge');
	}

	goProfile(){
		hashHistory.push('/profile');
	}

	render() {
		let user = this.state.userInfo;
		let balance = user.balance || {};
		let vipLevel = this.state.vipLevel;

		let $user = (
			<div className="profile-box"> 
				<div className="profile-box-hd">
					<div className="profile-avatar" onClick={()=>{this.goProfile()}}>
						<ImageView src={user.avatar} size={60} circle/>
					</div>
					<div className="profile-refs">
						<p className="username">
							<span onClick={()=>{this.goProfile()}}>{user.username}</span>
							<em onClick={()=>{this.goGrade()}}><Grade value={user.grade}/></em>
						</p>
						{ user.upliveCode ? <p className="upcode"><label>{lang.template('Up号')}</label><em>:{user.upliveCode}</em></p> : null}
					</div>
				</div>
				<ul className="profile-box-bd">
					<li className="diamond go" onClick={()=>{this.goRecharge()}}>
						<label>{lang.template('我的U钻')}</label>
						<em>{NumberUtil.separate(balance.diamond || 0)}</em>
					</li>
					<li className="vip go" onClick={()=>{this.goPrivilege()}}>
						<label>{lang.template('我的会员')}</label>
						{ vipLevel ? <em><VIP value={`${vipLevel.label}`}/></em> : <em><VIP value="VIP0"/></em>}
					</li>
					<li className="profile go" onClick={()=>this.goProfile()}>
						<label>{lang.template('个人主页')}</label>
						
					</li>
					<li className="account go" onClick={()=>this.goWithdraw() }>
						<label>{lang.template('我的账户')}</label>
						
					</li>
				</ul>
				<div className="profile-box-ft">
					<div onClick={()=>this.logout()}>{lang.template('注销')}</div>
				</div>
			</div>
		);

		return $user;
	}
}

export default Language;



// WEBPACK FOOTER //
// ./js/header/userlogin/index.js